
import {TWO_PI, SPI} from '../constants/values';
import sign from './sign';

export default function(x) {
  return (Math.abs(x) <= SPI) ? x : (x - (sign(x) * TWO_PI));
}



//////////////////
// WEBPACK FOOTER
// ./~/proj4/lib/common/adjust_lon.js
// module id = gkMG
// module chunks = 0